import { isRouteErrorResponse, Link, useRouteError } from "react-router-dom"
import { AlertTriangle, RotateCw } from "lucide-react"

import { Button } from "@/components/ui/button"
import { EmptyState } from "@/components/shared/empty-state"
import { NotFound } from "@/components/shared/not-found"

/** Rendered by the router when a page throws while loading or rendering. */
export function RouteError() {
  const error = useRouteError()

  if (isRouteErrorResponse(error) && error.status === 404) return <NotFound />

  // A new deploy invalidates old lazy chunks; a reload fetches the new ones.
  const message = error instanceof Error ? error.message : "An unexpected error occurred."
  const isChunkError = /dynamically imported module|Importing a module script failed/i.test(message)

  return (
    <EmptyState
      icon={AlertTriangle}
      title={isChunkError ? "A new version is available" : "Something went wrong"}
      description={isChunkError ? "Reload the page to get the latest version of the dashboard." : message}
      className="min-h-[60vh]"
      action={
        <div className="flex gap-2">
          <Button size="sm" onClick={() => window.location.reload()}>
            <RotateCw />
            Reload
          </Button>
          <Button asChild size="sm" variant="outline">
            <Link to="/dashboard">Dashboard</Link>
          </Button>
        </div>
      }
    />
  )
}
